import { useState } from 'react';
import type { GitStatus } from '@niuma/protocol';

interface Props {
  status: GitStatus | null;
  diff: string | null;
  busy: boolean;
  onRefresh: () => void;
}

/** Read-only git review: branch/status summary plus the working-tree diff. */
export function DiffReview({ status, diff, busy, onRefresh }: Props): JSX.Element {
  const [showDiff, setShowDiff] = useState(false);

  return (
    <section className="panel">
      <header className="panel-header">
        <div>
          <p className="eyebrow">git</p>
          <h2>Review</h2>
        </div>
        <div className="panel-actions">
          <button className="ghost" onClick={onRefresh} disabled={busy}>
            Refresh
          </button>
          <button onClick={() => setShowDiff((v) => !v)} disabled={!diff}>
            {showDiff ? 'Hide diff' : 'Show diff'}
          </button>
        </div>
      </header>

      {status ? (
        status.isGitRepo ? (
          <div className="git-status">
            <div className="git-branch">
              <span className="badge">{status.branch}</span>
              {status.clean ? (
                <span className="clean">clean</span>
              ) : (
                <span className="dirty">
                  {status.staged.length} staged · {status.unstaged.length} changed ·{' '}
                  {status.untracked.length} new
                </span>
              )}
              {(status.ahead > 0 || status.behind > 0) && (
                <span className="muted">
                  ↑{status.ahead} ↓{status.behind}
                </span>
              )}
            </div>
          </div>
        ) : (
          <p className="muted">Not a git repository.</p>
        )
      ) : (
        <p className="muted">Select a project to view git status.</p>
      )}

      {showDiff && diff && <pre className="diff">{diff}</pre>}
    </section>
  );
}
